<template>
  <button @click="exportTransaction" class="btn btn-info is-border-1 mr-1 mb-2">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
      no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
          :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import { saveAs } from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/zalo-oa', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let status = '';
          if (!item.sendTime) {
            status = this.$t('notYetSent');
          }
          if (item.sendTime && !item.sendError) {
            status = this.$t('sent');
          }
          if (item.sendTime && item.sendError) {
            status = this.$t('sentFail');
          }
          let row = {
            oa: item.oa && item.oa.name ? item.oa.name : '',
            user: item.user && item.user.name ? item.user.name + ` (${item.user.ext})` : '',
            zaloId: item.zaloId ? item.zaloId : '',
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            sendTime: moment(item.sendTime).format('DD/MM/YYYY HH:mm:ss'),
            messageCampaign: item.messageCampaign ? item.messageCampaign.name : '',
            template: item.template && item.template.name ? item.template.name : '',
            type: item.type ? this.$t(item.type + 'Message') : '',
            status: status,
            sendErrorMsg: item.sendErrorMsg ? item.sendErrorMsg : ''
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({ base64: true }).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          'zalo-oa-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        { header: 'OA', key: 'oa', width: 15 },
        { header: this.$t('user'), key: 'user', width: 20 },
        { header: 'Zalo ID', key: 'zaloId', width: 15 },
        { header: this.$t('createTime'), key: 'createTime', width: 20 },
        { header: this.$t('sendTime'), key: 'sendTime', width: 20 },
        { header: this.$t('messageCampaigns'), key: 'messageCampaign', width: 30 },
        { header: this.$t('template'), key: 'template', width: 30 },
        { header: this.$t('type'), key: 'type', width: 15 },
        { header: this.$t('status'), key: 'status', width: 15 },
        { header: this.$t('sendErrorMsg'), key: 'sendErrorMsg', width: 15 },
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        transactionMessage: "Transaction news",
        promotionMessage: "Personal media news",
        imageMessage: "Consulting message with photo attached",
        request_user_infoMessage: "Request user Information",
        csMessage: "Consulting messages",
      },
      vi: {
        transactionMessage: "Tin giao dịch",
        promotionMessage: "Tin truyền thông cá nhân",
        imageMessage: "Tin nhắn tư vấn đính kèm ảnh",
        request_user_infoMessage: "Yêu cầu thông tin người dùng",
        csMessage: "Tin nhắn tư vấn",
      }
    }
  }
}
</script>